import { Decimal } from ".";

export const toDecimal = (value: string | number | Decimal) =>
  new Decimal(value === "" ? 0 : value);
